import { CSSProperties, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

interface ImgProps {
  isLoaded?: boolean;
  style?: CSSProperties;
  src?: string;
  alt?: string;
  onLoad?: any;
}

export const Img = styled.img<ImgProps>`
  max-height: 51px;
  max-width: 102px;

  ${({ isLoaded }) => ({ display: isLoaded ? 'inherit' : 'none' })}

  ${({ style }) => ({ ...style })}
`;

interface WrapperProps {
  hasUrl?: boolean;
  style?: CSSProperties;
  to?: string;
  children?: ReactNode;
}

export const Wrapper = styled(NavLink)<WrapperProps>`
  padding: 0 28px 0 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  cursor: default;

  ${({ hasUrl }) =>
    hasUrl &&
    css`
      cursor: pointer;
    `}

  ${({ style }) => ({ ...style })}
`;

interface LinkProps {
  href?: string;
  children?: ReactNode;
}

export const Link = styled.a<LinkProps>``;
